import React, { Component } from 'react'
import MessageEditor from '../../components/Editor/MessageEditor'
import { Row, Col, Button } from 'reactstrap'
import {
  FormControl,
  InputAdornment,
  OutlinedInput,
  List,
  Divider,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material'
import Infobox from '../../components/Infos/Infobox'
import FalconModal from '../../components/Inputs/FalconModal'
import { withFirebase } from '../../components/Fb'
import {
  getMessagingListMessageSchema,
  getMessagingListMessageUISchema,
} from '../../components/Inputs/dataschemas'
import MessageListMessageDetails from '../../components/Details/MessageListMessageDetails'
import moment from 'moment-timezone'
import 'moment/locale/fi' // without this line it didn't work
import MailMarketingInfo from '../../components/Infos/MailMarketingInfo'
const service = 'mailmarketing'
const STATUS_TRANSLATIONS = {
  draft: 'Luonnos',
  scheduled: 'Ajoitettu',
  sent: 'Lähetetty',
}

class MessageItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: false,
      backgroundColor: 'white',
    }
  }

  componentDidMount() {
    if (this.props.message) {
      const status = this.props.message.status || 'draft'
      if (status === 'draft') {
        this.setState({ backgroundColor: '#9bd9d8' })
      } else if (status === 'scheduled') {
        this.setState({ backgroundColor: '#fff3cd' })
      } else {
        this.setState({ backgroundColor: 'white' })
      }
    }
  }

  handleRowSelect = (id) => {
    if (this.props.onSelect) this.props.onSelect(id)
  }

  render() {
    if (!this.props.message) return null
    const status = STATUS_TRANSLATIONS[this.props.message.status || 'draft']
    let time = ''//moment.unix(this.props.message.created.seconds).format('LL')
    if (
      this.props.message.status === 'scheduled' &&
      this.props.message.scheduled
    ) {
      time = moment
        .unix(this.props.message.scheduled.seconds)
        .format('LL, HH:mm')
    } else if (
      this.props.message.status === 'sent' &&
      this.props.message.senttimestamp
    ) {
      time = moment.unix(this.props.message.senttimestamp.seconds).format('LL, HH:mm')
    }

    return (
      <React.Fragment>
        <ListItem disablePadding style={{ width: '100%' }}>
          <ListItemButton
            alignItems='flex-start'
            style={{ backgroundColor: this.state.backgroundColor }}
            onClick={() => this.handleRowSelect(this.props.message.id)}
            // selected={this.state.selectedPersonIndex === row.id}
          >
            <ListItemText
              primary={this.props.message.title}
              secondary={
                <React.Fragment>
                  <Typography
                    sx={{ display: 'inline' }}
                    component='span'
                    variant='body2'
                    color='text.primary'
                  >
                    {status + (time ? ' - ' + time : '')}
                  </Typography>
                </React.Fragment>
              }
            />
          </ListItemButton>
        </ListItem>
        <Divider />
      </React.Fragment>
    )
  }
}

class MessagingListsMessagesContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedMessage: null,
      messageModalOpen: false,
      lists: [],
      messages: [],
      loading: true,
    }
  }

  loadMessages = (snapshot) => {
    let id = null
    if (snapshot) id = snapshot.id
    this.setState({ loading: true })
    this.props.firebase.getMessageListMessages().then((newmessages) => {
      let sel = null
      if (id) {
        sel = newmessages.find((m) => m.id === id)
      }
      this.setState({ messages: newmessages, loading: false, selectedMessage: sel })
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.modules && this.props.modules[service]) {
      const hasPrevModules = prevProps.modules && prevProps.modules[service]
      const wasEnabled = hasPrevModules && prevProps.modules[service].enabled
      const hasModules = this.props.modules && this.props.modules[service]
      const isEnabled = hasModules && this.props.modules[service].enabled
      if (isEnabled && !wasEnabled) {
        this.setState({ enabled: true })
      } else if (!isEnabled && wasEnabled) {
        this.setState({ enabled: false })
      } else if (!hasModules && wasEnabled) {
        this.setState({ enabled: false })
      } 
    } else {
      if (this.state.enabled) {
        this.setState({ enabled: false })
      }
    }
  }

  componentDidMount() {
    Promise.all([
      this.props.firebase.getMessagingLists(),
      this.props.firebase.getMessageListMessages(),
    ])
      .then(([lists, messages]) => {
        this.setState({
          messages,
          loading: false,
          selectedMessage: null,
          lists,
          saving: false,
          enabled:
            this.props.modules &&
            this.props.modules[service] &&
            this.props.modules[service].enabled,
        })
      })
      .catch((error) => console.error(error), this.setState({ loading: false }))
  }

  toggleMessageModal = () => {
    this.setState({ messageModalOpen: !this.state.messageModalOpen })
  }

  addNewMessage = () => {
    this.setState({ selectedMessage: {} }, this.toggleMessageModal)
  }

  getMessagingListMessageSchemaWithLists = () => {
    const schema = getMessagingListMessageSchema()
    const activeLists = (this.state.lists || []).filter((l) => l.state !== 'deleted')
    if (!activeLists.length) {
      schema.properties.listids.items = { type: 'string', oneOf: [{ const: 'nodata', title: 'Luo viestilista, jotta voit valita listan' }] }
      schema.properties.listids.description =
        'Viestilistaa ei ole saatavilla. Luo viestilista, jotta voit valita listan.'
      schema.properties.listids.readOnly = true
      return schema
    }
    const sorted = activeLists.sort((a, b) => (a.name || '').localeCompare(b.name || ''))
    schema.properties.listids.items = {
      type: 'string',
      oneOf: sorted.map((list) => ({
        const: list.id,
        title: list.name || list.id,
      })),
    }
    return schema
  }

  handleRowSelect = (id) => {
    const message = this.state.messages.find((r) => r.id === id)
    console.log('SELECT', message)
    this.setState({ selectedMessage: message })
  }

  enableModule = async (price) => {
    this.setState({ saving: true })
    await this.props.firebase.enableModule(service, price)
  }

  disableModule = async () => {
    this.setState({ saving: true })
    await this.props.firebase.disableModule(service)
  }

  // createNewMessage = (message) => {
  //   console.log('adding new message', message)
  //   this.props.firebase.createMessageListMessage(message).then((newMessage) => {
  //     console.log('newMessage', newMessage)
  //   })
  // }

  render() {
    return (
      <React.Fragment>
        <div className='content' style={{ height: '75vh' }}>
          {!this.state.enabled && (
            <MailMarketingInfo
              onSubmit={this.enableModule}
              saving={this.state.saving}
            />
          )}

          {this.state.enabled && (
            <React.Fragment>
              <Row className='pt-1 pb-2'>
                <Col md='4'>
                  <Button onClick={this.addNewMessage}>Uusi viesti</Button>
                  <FormControl
                    fullWidth
                    style={{ backgroundColor: 'white' }}
                  ></FormControl>
                </Col>
                <Col md='5'>
                  <Infobox index={'0'} />
                </Col>
                <Col md='3'></Col>
              </Row>
              <Row className='no-gutters'>
                <Col
                  md='3'
                  className='border-right no-gutters'
                  style={{ minHeight: '100vh' }}
                >
                  <List
                    component='nav'
                    style={{
                      padding: 0,
                      maxHeight: '80vh',
                      position: 'relative',
                      overflow: 'auto',
                    }}
                  >
                    {this.state.messages && this.state.messages.length > 0 ? (
                      this.state.messages.map((row) => (
                        <MessageItem
                          key={row.id}
                          message={row}
                          onSelect={this.handleRowSelect}
                        />
                      ))
                    ) : (
                      <div>Ei viestejä</div>
                    )}
                  </List>
                </Col>
                <Col md='9'>
                  {this.state.selectedMessage && this.state.selectedMessage.id ? (
                    <MessageListMessageDetails
                      message={this.state.selectedMessage}
                      {...this.props}
                    />
                  ) : (
                    ''
                  )}
                </Col>
              </Row>
            </React.Fragment>
          )}
        </div>
        <FalconModal
          onUpdate={this.props.firebase.updateMessageListMessage}
          onCreate={this.props.firebase.createMessageListMessage}
          modifiedCallback={this.loadMessages}
          toggle={this.toggleMessageModal}
          resource={this.state.selectedMessage}
          isOpen={this.state.messageModalOpen}
          uiSchema={getMessagingListMessageUISchema()}
          dataSchema={this.getMessagingListMessageSchemaWithLists()}
          title={
            this.state.selectedMessage && this.state.selectedMessage.id
              ? 'Muokkaa viestiä'
              : 'Uusi viesti'
          }
          disableSave={this.state.lists.length === 0}
        />
      </React.Fragment>
    )
  }
}
export default withFirebase(MessagingListsMessagesContainer)
